import http from '../auth/httpService';

const apiEndPoint = '/programs';

function programUrl(id) {
  return `${apiEndPoint}/${id}`;
}

export function getPrograms() {
  return http.get(apiEndPoint);
}

export function getProgram(programId) {
  return http.get(programUrl(programId));
}


export function saveProgram(program) {
  if (program.id) {
    const body = { ...program };
    delete body.id;
    return http.put(programUrl(program.id), body);
  }
  return http.post(apiEndPoint, program);
}

export function deleteProgram(programId) {
  return http.delete(programUrl(programId));
}

